import { render, staticRenderFns } from "./reporting-group-2.vue?vue&type=template&id=ed0dd274"
import script from "./reporting-group-2.vue?vue&type=script&lang=js"
export * from "./reporting-group-2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports